var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgJiaoyi = function SvgJiaoyi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.711 8.7a5 5 0 0 1 5 5v4.417a5 5 0 0 1 3 4.583v4.5a.5.5 0 0 1-.5.5h-16.5a7 7 0 1 0 0 14h16.5a.5.5 0 0 1 .5.5v4.5a5 5 0 0 1-5 5h-40.5a6.5 6.5 0 0 1-6.5-6.5v-30a6.5 6.5 0 0 1 6.5-6.5h37.5Zm7.5 19.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-16.5a6.5 6.5 0 0 1 0-13h16.5Zm-16.5 5.5a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2h-3Zm-28.5-21a2.5 2.5 0 1 0 0 5h38.5v-4a1 1 0 0 0-1-1h-37.5Z",
    fill: "url(#jiaoyi_svg__a)",
    stroke: "url(#jiaoyi_svg__b)",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jiaoyi_svg__a",
    x1: 30.711,
    y1: 9.2,
    x2: 30.711,
    y2: 51.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jiaoyi_svg__b",
    x1: 30.711,
    y1: 9.2,
    x2: 30.711,
    y2: 51.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};

export default SvgJiaoyi;